export default {
      id: "log_out-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#log_out",
      toString: function () {
        return this.url;
      }
    }